"use strict";
exports.__esModule = true;
exports.RuleRequestType = exports.FactType = exports.Entity = exports.RuleCategory = exports.AttributeDatatype = void 0;
var AttributeDatatype;
(function (AttributeDatatype) {
    AttributeDatatype[AttributeDatatype["String"] = 0] = "String";
    AttributeDatatype[AttributeDatatype["Number"] = 1] = "Number";
    AttributeDatatype[AttributeDatatype["Boolean"] = 2] = "Boolean";
})(AttributeDatatype = exports.AttributeDatatype || (exports.AttributeDatatype = {}));
var RuleCategory;
(function (RuleCategory) {
    RuleCategory[RuleCategory["FleetRouter"] = 0] = "FleetRouter";
    RuleCategory[RuleCategory["Action"] = 1] = "Action";
})(RuleCategory = exports.RuleCategory || (exports.RuleCategory = {}));
var Entity;
(function (Entity) {
    Entity["Fleet"] = "fleet";
    Entity["Action"] = "action";
})(Entity = exports.Entity || (exports.Entity = {}));
var FactType;
(function (FactType) {
    FactType[FactType["Task"] = 0] = "Task";
})(FactType = exports.FactType || (exports.FactType = {}));
var RuleRequestType;
(function (RuleRequestType) {
    RuleRequestType["Evaluate"] = "rule:evaluate";
})(RuleRequestType = exports.RuleRequestType || (exports.RuleRequestType = {}));
//# sourceMappingURL=rule_types.js.map